import React, { Component } from 'react';
import './../css/master.css';
import './../css/pendingChanges.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';

var httpURL = '';
var queryString = require('querystring');
var lstPendingChanges = [];
var sortVal = "";
var lstProgress = [];
var lstCombine = [];
var pendingCbx = "";


class pendingChanges extends Component {
    constructor(props) {
        super(props);
        this.state = {

            designNoColor: [],
            flg: true,
            //flgPODesign : true,
            flgStyle: true,
            deliveryDate: null,
            startDate: new Date(),
            endDate: null,
            minDate: null,
            loader: 'none',
            progress: '',
            opacity: 1,
            width: '99%',
            flgAdd: true,
            dispReport: '',
            src: require('./../images/blank.png'),
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleChange1 = this.handleChange1.bind(this);
    }
    handleChange(date) {
        this.setState({
            startDate: date,
        });
    }
    handleChange1(date) {
        this.setState({
            endDate: date
        });
    }


    async componentDidMount() {
        this.setState({ loader: 'block', opacity: 0.5 });
        this.getPendingChangesData();

        this.setState({ loader: 'display', opacity: 0.5 });



    }

    getPendingChangesData = () => {
        axiosInstance.post(httpURL + '/a/ipo/pendingchanges/list',
        ).then((response) => {
            if (response.data.SvcStatus === "Success") {
                lstPendingChanges = response.data.lstPendingChanges;
            }
            else {
                toast.error(response.data.SvcMsg)
                if (response.data.SvcMsg == 'No Data Exist') {
                    lstPendingChanges = [];
                }
                if (response.data.SvcMsg == 'You are not logged in') {
                    window.location.href = window.CSURL;
                    return false;
                }
            }
            this.setPendingChangesTable();
        }).catch((e) => {
            toast.error("Service failed " + e);
        });
    }


    setPendingChangesTable = () => {
        $('#pendingChangesTableBody tr').remove();
        var table = document.getElementById('pendingChangesTable');
        var tbody = document.getElementById('pendingChangesTableBody');
        var filterIpo = $('#ipo').val().trim().toLowerCase();
        var filterWeaver = $('#filterWeaver').val().trim().toLowerCase();

        for (var i = 0; i < lstPendingChanges.length; i++) {
            var weaverDelDt = lstPendingChanges[i].weaverDeliveryDt === null ? "-" : lstPendingChanges[i].weaverDeliveryDt;
            var buyerDeliveryDt = lstPendingChanges[i].buyerDeliveryDt === null ? "-" : lstPendingChanges[i].buyerDeliveryDt;
            var ipoNo = lstPendingChanges[i].ipoNo;
            var bpo = lstPendingChanges[i].bpo === null ? "-" : lstPendingChanges[i].bpo;
            var designNoColor = lstPendingChanges[i].designNoColor;
            var newProgress1 = lstPendingChanges[i].newProgress1;
            var newProgress2 = lstPendingChanges[i].newProgress2;
            var newProgress3 = lstPendingChanges[i].newProgress3;
            var newProgressSubmitDtTm = lstPendingChanges[i].newProgressSubmitDtTm;
            var yasrdageDt = lstPendingChanges[i].yardageDt;
            var yardageStatus = lstPendingChanges[i].yardageStatus;
            var oldProgress1 = lstPendingChanges[i].oldProgress1;
            var oldProgress2 = lstPendingChanges[i].oldProgress2;
            var oldProgress3 = lstPendingChanges[i].oldProgress3;
            var oldProgressSubmitDtTm = lstPendingChanges[i].oldProgressSubmitDtTm;
            var weaver = lstPendingChanges[i].weaver;
            var ipoDesignId = lstPendingChanges[i].ipoDesignId;
            var progressId = lstPendingChanges[i].progressId;
            var status = 1;
            var reasonStatus = 0;
            var button = "save";
            var row = document.createElement('tr');
            if (ipoNo.toLowerCase().indexOf(filterIpo) === -1)
                continue;
            if (weaver.toLowerCase().indexOf(filterWeaver) === -1)
                continue;
            this.addTD(row, ipoDesignId, 'no-display');
            this.addTD(row, progressId, 'no-display');
            this.addTD(row, weaverDelDt, '');
            this.addTD(row, buyerDeliveryDt, '');
            this.addTD(row, ipoNo, 'text-left');
            this.addTD(row, bpo, 'text-center');
            this.addTD(row, designNoColor, 'text-center');
            this.addTD(row, weaver, '');
            this.addTD(row, yasrdageDt, 'text-center');
            this.addTD(row, yardageStatus, 'text-center');
            this.addTD(row, oldProgressSubmitDtTm, 'text-center');
            this.addTD(row, oldProgress1, 'text-center changes1');
            this.addTD(row, oldProgress2, 'text-center changes1');
            this.addTD(row, oldProgress3, 'text-center changes1');
            this.addTD(row, newProgressSubmitDtTm, 'text-center');
            if (oldProgress1 != newProgress1) {
                this.addTD(row, newProgress1, 'text-center changes');
            }
            else {
                this.addTD(row, newProgress1, 'text-center changes1');
            }
            if (oldProgress2 != newProgress2) {
                this.addTD(row, newProgress2, 'text-center changes');
            }
            else {
                this.addTD(row, newProgress2, 'text-center changes1');
            }
            if (oldProgress3 != newProgress3) {
                this.addTD(row, newProgress3, 'text-center changes');
            }
            else {
                this.addTD(row, newProgress3, 'text-center changes1');
            }
            this.addTDCmb(row, status, '');
            this.addTDCmb1(row, reasonStatus, 'text-center');
            this.addTDBtn(row, 'glyphicon glyphicon-saved', 'text-center');


            $(row).find("td").attr({ width: "100" });
            tbody.append(row);
        }
        table.append(tbody);
    }

    addTD(row, val, classname) {
        var cell = document.createElement('td');
        cell.className = classname;
        if (val == '-') {
            cell.style.textAlign = 'center';
        }
        var text = document.createTextNode(val);
        cell.append(text);
        row.append(cell);
    }
    addTDCmb(row, val, classname) {
        var cell = document.createElement('td');
        cell.className = classname;
        var select = document.createElement('select');
        select.className = 'form-control';
        var option1 = document.createElement('option');
        var option2 = document.createElement('option');
        var option3 = document.createElement('option');
        option1.value = 1;
        option2.value = 2;
        option3.value = 3;
        option1.innerHTML = 'Pending';
        option2.innerHTML = 'Approve';
        option3.innerHTML = 'Reject';
        select.append(option1);
        select.append(option2);
        select.append(option3);
        cell.append(select);
        select.value = val;
        row.append(cell);
    }
    addTDCmb1(row, val, classname) {
        var cell = document.createElement('td');
        cell.className = classname;
        var select = document.createElement('select');
        select.className = 'form-control';
        select.id = 'selectReason';
        select.addEventListener('change', this.checkReasonStatus);
        var option1 = document.createElement('option');
        var option2 = document.createElement('option');
        var option3 = document.createElement('option');
        var option4 = document.createElement('option');
        var option5 = document.createElement('option');
        var option6 = document.createElement('option');
        var option7 = document.createElement('option');
        var option8 = document.createElement('option');
        var option9 = document.createElement('option');
        var option10 = document.createElement('option');

        option1.value = 0;
        option2.value = 1;
        option3.value = 2;
        option4.value = 3;
        option5.value = 4;
        option6.value = 5;
        option7.value = 6;
        option8.value = 7;
        option9.value = 8;
        option10.value = 9;
        option1.innerHTML = 'Status';
        option2.innerHTML = 'Approval delayed';
        option3.innerHTML = 'Change in Order Quantity';
        option4.innerHTML = 'Payment delay to weaver';
        option5.innerHTML = 'Color cutting delay';
        option6.innerHTML = 'Wrong planning';
        option7.innerHTML = 'Non availability of yarn';
        option8.innerHTML = 'Wrong color matching';
        option9.innerHTML = 'Wants to Hold';
        option10.innerHTML = 'Payment delay to CS';

        select.append(option1);
        select.append(option2);
        select.append(option3);
        select.append(option4);
        select.append(option5);
        select.append(option6);
        select.append(option7);
        select.append(option8);
        select.append(option9);
        select.append(option10);
        cell.append(select);
        select.value = val;
        row.append(cell);
    }

    addTDBtn(row, val, classname) {
        var cell = document.createElement('td');
        cell.className = classname;
        var span = document.createElement('span');
        span.className = val;
        span.style.cursor = 'pointer';
        span.setAttribute('title', 'save');
        span.addEventListener('click', this.saveWorkStatus);
        cell.append(span);
        row.append(cell);
    }

    saveWorkStatus = (e) => {
        var ipoDesignId = $(e.target).closest('tr').find('td:eq(0)').text();
        var progressStatusId = $(e.target).closest('tr').find('option:selected').val();
        var reasonId = $(e.target).closest('tr').find('#selectReason option:selected').val();
        var progressId = $(e.target).closest('tr').find('td:eq(1)').text();

        var progress = { ipoDesignId, progressId, progressStatusId, reasonId };
        this.setState({ loader: 'block', opacity: 0.5 });

        axiosInstance.post(httpURL + '/a/ipo/prog/saveprogress',
            queryString.stringify({ 'progress': JSON.stringify(progress) }), { withCredentials: true }
        ).then((response) => {
            if (response.data.SvcStatus === 'Success') {
                toast.success(response.data.SvcMsg);
                // lstProgress[0].progressStatusId = progressStatusId;
                // lstProgress[0].reasonId = reasonId;
                // lstProgress[0].progressActionDt = response.data.progressActionDt;
                this.getPendingChangesData();
            }
            else {
                toast.error(response.data.SvcMsg);
                if (response.data.SvcMsg == 'You are not logged in') {
                    window.location.href = window.CSURL;
                    return false;
                }
            }
            this.setState({ loader: 'none', opacity: 1 });
        }).catch((error) => {
            toast.error("Service failed " + error);
        });

    }

    checkReasonStatus = (e) => {
        var val = $(e.target).find('option:selected').val();
        this.setState({
            reasonId: val,
        });
    }

    handleResize = () => {
        var width = ($('.tableHeadReportDiv').parent().width()) - 18;
        this.setState({ width: width })
    }


    sortAscByPo = () => {
        if (sortVal != 'aspo') {
            sortVal = 'aspo';
            $("#poAsDtIcon").css("color", "white");
            $("#poDsDtIcon").css("color", "#f1f1f1");
            $("#deliveryAsDtIcon").css("color", "#f1f1f1");
            $("#deliveryDsDtIcon").css("color", "#f1f1f1");

            var val1;
            var val2;

            for (var i = 0; i < lstPendingChanges.length - 1; i++) {
                val1 = lstPendingChanges[i].ipoNo;
                for (var j = i + 1; j < lstPendingChanges.length; j++) {
                    val2 = lstPendingChanges[j].ipoNo;
                    if (val1 > val2) {
                        var tmp = lstPendingChanges[j];
                        lstPendingChanges[j] = lstPendingChanges[i];
                        lstPendingChanges[i] = tmp;
                        val1 = lstPendingChanges[i].ipoNo;
                    }
                }
            }
            this.setPendingChangesTable();
        }
    }


    render() {
        httpURL = window.httpURL;
        return (
            <div style={{ height: '100%' }}>
                <Header />
                <ToastContainer autoClose={2000} hideProgressBar />
                <div className="main">
                    <div className="container-fluid">
                        <div className="col-sm-12 padding-remove" style={{ overflowX: 'hidden' }}>
                            <div className="tablePendingChangesDiv" style={{ width: this.state.width }}>
                                <table id="tableWorkReport" className="tableLayout1">
                                    <thead>
                                        <tr>

                                            <th style={{ width: 25 }}>Buyer <br /> Del.Dt.</th>
                                            <th style={{ width: 25 }}>Weaver <br /> Del.Dt.</th>
                                            <th style={{ width: 35 }}>
                                                <div style={{ float: 'left', width: '80%' }}>
                                                    <input type="text" onChange={this.setPendingChangesTable} className="form-control inp-search" id="ipo" placeholder="IPO" />

                                                </div>
                                                <div style={{ width: 10, float: 'left', marginLeft: 2, marginTop: 4 }}>
                                                    <div className="assending">
                                                        <span id="poAsDtIcon" onClick={this.sortAscByPo} className="glyphicon glyphicon-triangle-top"></span>
                                                    </div>
                                                    <div className="desending">
                                                        <span id="poDsDtIcon" onClick={this.sortDesByPo} className="glyphicon glyphicon-triangle-bottom"></span>
                                                    </div>
                                                </div>
                                            </th>
                                            <th style={{ width: 25 }}>Buyer Po</th>
                                            <th style={{ width: 40 }}>DesignNoColor</th>
                                            <th style={{ width: 35 }}>
                                                <div style={{ float: 'left', width: '100%' }}>
                                                    <input type="text" onChange={this.setPendingChangesTable} className="form-control inp-search" id="filterWeaver" placeholder="Weaver" />
                                                </div>
                                            </th>
                                            <th style={{ width: 30 }}>Yardage <br /> Date</th>
                                            <th style={{ width: 35 }}>PP Yardage<br /> Status</th>

                                            {/* <th style={{ width: 88 }}>Balance</th> */}
                                            <th className="balanceCol" style={{ width: 90, }}>
                                                <div className="balanceWrap1">Old Status </div>
                                                <div className="balanceWrap">
                                                    <span className=" loom text-center onLoomSub onLoom"> Submit <br />Date/Time</span>
                                                    <span className=" loom text-center onLoom"> 25%</span>
                                                    <span className=" loom text-center onLoom"> 50%</span>
                                                    <span className=" loom text-center">100%</span>
                                                </div>
                                            </th>
                                            <th className="balanceCol" style={{ width: 88, }}>
                                                <div className="balanceWrap1">New Status </div>
                                                <div className="balanceWrap">
                                                    <span className=" loom text-center onLoomSub onLoom"> Submit <br />Date/Time</span>
                                                    <span className=" loom text-center onLoom"> 25%</span>
                                                    <span className=" loom text-center onLoom"> 50%</span>
                                                    <span className=" loom text-center">100%</span>
                                                </div>
                                            </th>
                                            <th style={{ width: 35 }}> Status</th>
                                            <th style={{ width: 35 }}>Reason</th>
                                            <th style={{ width: 22 }}>Action</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className="workSummaryTableDiv" onScroll={this.theadScroll}>
                                <div style={{ width: '100%' }} >
                                    <table id="pendingChangesTable" className="tableLayout">
                                        <colgroup>
                                            <col width="25" />
                                            <col width="25" />
                                            <col width="35" />
                                            <col width="25" />
                                            <col width="40" />
                                            <col width="35" />
                                            <col width="30" />
                                            <col width="35" />
                                            <col width="35" />
                                            <col width="18" />
                                            <col width="18" />
                                            <col width="18" />
                                            <col width="35" />
                                            <col width="18" />
                                            <col width="18" />
                                            <col width="18" />
                                            <col width="35" />
                                            <col width="35" />
                                            <col width="20" />
                                        </colgroup>
                                        <tbody id="pendingChangesTableBody"></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default pendingChanges;
